// router links for Onelynk
export enum RouteLink {
  Gateway = "/gateway",
  Login = "/main/login",
  ServiceUnavailable = "/main/service-unavailable",

  CheckAuth = "/check-auth",
  Home = "/main/home",
  Services = "/main/services",
  HR = "/main/services/hr",
  Finance = "/main/services/finance",
  OrderMgt = "/main/services/finance",
  ESS = "/main/services/ess",
  MSS = "/main/services/mss",
  Procurement = "/main/services/finance",
  Help = "/main/help-center",
  CorpCalendar = "/main/corp-calendar",
  Delegation = "/main/delegation",
  Worklist = "/main/worklist",

  //File Sharing
  FileSharingOnboardingFiles = "/main/file-sharing/onboarding-files",
  FileSharingMaintenanceFiles = "/main/file-sharing/maintenance-files",

  //Reporting
  Reporting = "/reporting/reporting-main",

  // Calendar links
  FinanceCalendar = "/finance/calendar",
  HrCalendar = "/hcm/calendar",


  // ESS links
  Profile = "/hcm/ess/profile",
  LeaveRequest = "/hcm/ess/leave-request",
  VacationRequest = "/hcm/ess/vacation-request",
  TrainingRequest = "/hcm/ess/training-request",
  SelfAppraisal = "/hcm/ess/self-appraisal",
  BenefitSelection = "/hcm/ess/benefits-summary",
  QualifyingLifeEvent = "/hcm/ess/qualifying-life-event",

  // MSS links
  EmployeeAppraisal = "/hcm/common/employee-appraisal",
  EmployeeChangeRequest = "/hcm/mss/employee-change-request",
  EmployeeLeaveHistory = "/hcm/mss/employee-leave-history",

  // Timesheet & Expense links
  ExpenseReport = "/finance/expense/expense-report",
  Timesheet = "/finance/time/timesheet",
  TimesheetManager = "/finance/time/timesheet-summary/Manager",
  TimesheetPayroll = "/finance/time/timesheet-summary/Payroll",
  TimesheetAdmin = "/finance/time/timesheet-admin",


  // CMMC
  CyberplanSystemsSummary = "/cyberplan/systems-summary",
  CyberplanSecuritySystem = "/cyberplan/security-system",
  CyberplanSecurityAssessment = "/cyberplan/security-assessment",
  CyberplanSecurityPolicy = "/cyberplan/security-policy",
  CyberplanSecurityThreat = "/cyberplan/security-threat",
  CyberplanRemediationAction = "/cyberplan/security-remediation-action",
  CyberplanAssessmentPathParamSystemId = "systemId",
  CyberplanRemediationPathParamAssessmentId = "assessmentId",
  CyberplanBaseSystemPathParam = "baseSystemId",
  CyberplanSystemIdPathParam = "id",

  // Charge Code links
  ChargeCodeAdmin = "/finance/charge-code/charge-code-admin",
  AccountGroup = "/finance/charge-code/account-group",
  AccountMapping = "/finance/charge-code/account-mapping",
  WorkAuthSummary = "/finance/charge-code/work-auth-summary",
  WorkAuth = "/finance/charge-code/work-auth",
  WorkAuthRequest = "/finance/charge-code/work-auth-request",
  WorkAuthAdmin = "/finance/charge-code/work-auth-admin",

  // Recruit to Hire links
  AssetProvision = "/hcm/recruit-to-hire/asset-provision",
  RecruitToHire = "/hcm/recruit-to-hire/job-req-summary",
  JobReq = "/hcm/recruit-to-hire/job-req",
  Candidate = "/hcm/recruit-to-hire/candidate",
  CandidateTracking = "/hcm/recruit-to-hire/candidate-tracking",
  CandidateInterview = "/hcm/recruit-to-hire/interview-feedback",
  NewHireRequest = "/hcm/recruit-to-hire/new-hire",
  PreOnboard = "/hcm/recruit-to-hire/pre-onboard",
  VirtualOrientation = "/hcm/recruit-to-hire/virtual-orientation",

  // Recruit to Hire Candidate links
  CandidateHome = "/candidate/home",
  EmploymentApplication = "/hcm/recruit-to-hire/employment-application",
  JobOffer = "/candidate/job-offer",

  // Customer links
  CustomerHome = "/customer/home",

  // HR links
  AppraisalAdmin = "/hcm/hr/appraisal-admin",
  BenefitProvider = "/hcm/hr/benefit-management",
  EmployeeClass = "/hcm/hr/employee-class",
  CandidateDataManagement = "/hcm/hr/candidate-data-management",
  CustomerDataManagement = "/hcm/hr/customer-data-management",
  ConsultantDataManagement = "/hcm/hr/consultant-data-management",
  ContractorDataManagement = "/hcm/hr/contractor-data-management",
  EmployeeDataManagement = "/hcm/hr/employee-data-management",
  EmployeeOffboardingChecklist = "/hcm/hr/employee-offboard-checklist",
  EmployeeOffboardingChecklistDetails = "/hcm/hr/employee-offboard-checklist-details",
  AssetDeProvision = "/hcm/hr/asset-de-provision",
  ResourceManagement = "/hcm/hr/resource-search",
  JobPostingSite = "/hcm/hr/job-posting-site",
  OfferLetter = "/hcm/hr/offer-letter",
  OfferLetterClause = "/hcm/hr/offer-letter-clause",
  Position = "/hcm/hr/position",
  PositionGrade = "/hcm/hr/position-grade",
  ProviderDetails = "/hcm/hr/provider-details",
  PtoPolicy = "/hcm/hr/pto-policy",
  ScreeningQuestion = "/hcm/hr/screening-question",
  ScreeningQuestionCategory = "/hcm/hr/screening-question-category",


  // Account Payable links
  AccountPayable = "/finance/accounts-payable/main",
  PaymentTermAdmin = "/finance/payment-terms-admin",
  ReceiptInvoiceReturn = "/finance/accounts-payable/receipt-invoice-return",
  //Receipt = "/finance/accounts-payable/receipt-invoice-return/RECEIPT",
  PurchaseReturn = "/finance/accounts-payable/purchase-return",
  Receipt = "/finance/accounts-payable/receipt",
  VendorInvoice = "/finance/accounts-payable/vendor-invoice",
  //VendorInvoice = "/finance/accounts-payable/receipt-invoice-return/VENDOR_INVOICE",
  PaymentRegister = "/finance/payment-register",
  FinancialReport = "/finance/financial-report",
  VoucherRegister = "/finance/voucher-register",

  // Account Receivable links
  AccountReceivable = "/finance/accounts-receivable/main",
  PackingSlipInvoiceReturn = "/finance/accounts-receivable/packingslip-invoice-return",
  SalesReturn = "/finance/accounts-receivable/sales-return",
  CustomerInvoice = "/finance/accounts-receivable/customer-invoice",
  CatalogCustomerInvoice = "/finance/accounts-receivable/catalog-invoice",
  CatalogCustomerInvoiceGeneration = "/finance/accounts-receivable/catalog-invoice/new",  // Overloaded route link to differentiate between new invoice vs
  // viewing attachments.
  ManualContractProjectCustomerInvoice = "/finance/accounts-receivable/manual-contract-project-invoice",
  ContractProjectCustomerInvoice = "/finance/accounts-receivable/contract-project-invoice",
  PackingSlip = "/finance/accounts-receivable/packing-slip",
  RevenueRecognition = "/finance/accounts-receivable/revenue-recognition",

  // General Ledgerlinks
  GeneralLedger = "/finance/general-ledger/main",
  GeneralLedgerDetail = "/finance/general-ledger/detail",
  GeneralLedgerPeriodBalances = "/finance/general-ledger/period-balance",

  JournalEntryTemplate = "/finance/general-ledger/journal-entry-template",
  ProvisionalRateChange = "/finance/general-ledger/provisional-rate-changes",

  // Purchase Req links
  PurchaseRequisition = "/procurement/purchase-requisition",

  // Sales Order links
  SalesOrder = "/procurement/sales-order",

  // Contract/Project Links
  ContractSummary = "/project/contract-summary",
  ContractBidLink = "/project/contract-summary",
  ProjectContract = "/project/contract",
  ProjectContractBid = "/project/contract-bid",
  BidTab = "bid",
  ContractTab = "contract",
  ProjectSummary = "/project/project-summary",
  ProjectEstimateLink = "/project/project-summary",
  ProjectTab = "project",
  Project = "/project/project",
  ProjectEstimate = "/project/project",
  EstimateTab = "estimate",
  BillingPlan = "/project/billing-plan",
  BillingPlanSummary = "/project/billing-plan-summary",
  AtRiskRequest = "/project/at-risk-request",
  FeeSchedule = "/project/fee-schedule",

  // Project links
  EstimatesAndProjects = "/project/project-summary",
  ProjectCatalog = "/project/project-catalog",
  ProjectStatusReport = "/project/project-status-report",
  ContractProjectPnL = "/project/contract-project-pnl",

  // Trading Partner links
  TradingPartner = "/trading-partner/org",
  TradingPartnerSummary = "/trading-partner/summary",
  Vendor = "/trading-partner/summary/VENDOR",
  Customer = "/trading-partner/summary/CUSTOMER",

  // Item Catalog links
  ItemCatalogAdmin = "/item-catalog/admin",
  ItemCatalogInventory = "/item-catalog/physical-inventory",

  // Payroll links
  Payroll = "/payroll/payroll-main",
  PayrollRegister = "/payroll/payroll-register",
  PayrollRegisterDetails = "/payroll/payroll-register-details",

  // Test links
  TestFileExplorer = "/test/test-file-explorer",
  TestAddLineItem = "/test/test-add-line-item",
  TestRecruitToHire = "/test/test-recruit-to-hire",
  TestCommonUtil = "/test/test-common-util",
  TestLeaveHistory = "/test/test-leave-history",
  TestTimesheetSummary = "/test/test-timesheet-summary",
  TestUxPrinciples = "/test/test-ux-principles",

  // Solution Manager
  RevenueManagement = "/solution-manager/revenue-management",
  OrgDefaultPricing = "/solution-manager/org-default-pricing",
  SolMgrImport = "/solution-manager/data-import",
  SolMgrMain = "/solution-manager/main",
  SolMgrOrgSetupValidation = "/solution-manager/org-setup-validation",
  SolMgrTransactionValidation = "/solution-manager/transaction-validation",
  SolMgrDataImport = "/solution-manager/transaction-data-import",
  SolMgrVendorInvoiceImport = "/solution-manager/vendor-invoice-import",
  SolMgrVendorExpenseImport = "/solution-manager/expense-report-import",
  SolMgrOrgInfo = "/solution-manager/org-info",
  SolMgrRealm = "/solution-manager/realm",
  SolMgrOrgSummary = "/solution-manager/org-summary",
  SolMgrPeople = "/solution-manager/people",

  // Solution Manager Asset & Document
  SolMgrDocType = "/solution-manager/document/doc-type",
  SolMgrDocAttr = "/solution-manager/document/doc-attribute",
  SolMgrDocNumber = "/solution-manager/system/doc-number",
  SolMgrOrgDoc = "/solution-manager/document/org-document",
  SolMgrOrgPayrollTax = "/solution-manager/document/org-payroll-tax",
  SolMgrOrgAsset = "/solution-manager/org-asset",

  // Solution Manager System
  SolMgrAdminServices = "/solution-manager/system/admin-services",
  SolMgrTimeSheetReconcile = "/solution-manager/system/timesheet-reconcile",
  SolMgrAdditionalInfo = "/solution-manager/system/additional-info",
  SolMgrCorrespondence = "/solution-manager/system/correspondence-category",
  SolMgrMasterCatalog = "/solution-manager/system/master-catalog",
  SolMgrPdfTemplate = "/solution-manager/system/pdf-template",
  SolMgrPerdiemRates = "/solution-manager/system/perdiem-rates",
  SolMgrOrgFile = "/solution-manager/system/org-file",
  SolMgrRefDomain = "/solution-manager/system/ref-domain",
  SolMgrRefCode = "/solution-manager/system/ref-code",
  SolMgrSystemParam = "/solution-manager/system/system-param",
  SolMgrRetirementLimits = "/solution-manager/system/retirement-limits",
  SolMgrToDo = "/solution-manager/system/to-do",
  SolMgrChartOfAccountsSetup = "/solution-manager/system/chart-of-accounts-setup",
  ChartOfAccountSetupFinancePath = 'finance',
  ChartOfAccountSetupSolMgrPath = 'solution',
  ChartOfAccountSetupCoa = 'coa',
  ChartOfAccountSetupCostPoolTab = 'cost-pool',
  SolMgrModelOptionsSummary = "/solution-manager/system/model-options-summary",
  SolMgrModelOption = "/solution-manager/system/model-options/",
  SolMgrAccountingCloseTasks = "/solution-manager/system/accounting-close-tasks",
  SolMgrAccountSetting = "/solution-manager/system/account-setting",
  SolMgrComplianceAgency = "/solution-manager/system/compliance-agency",
  SolMgrTimesheetPayType = "/solution-manager/system/timesheet-pay-type",
  SolMgrTaskBalance = "/solution-manager/system/task-balance-admin",

  // Solution Manager Workflow
  SolMgrAuthorizationPolicy = "/solution-manager/workflow/authorization-policy",
  SolMgrDelegationPolicy = "/solution-manager/workflow/delegation-policy",
  SolMgrEscalationPolicy = "/solution-manager/workflow/escalation-policy",
  SolMgrApprovalPolicy = "/solution-manager/workflow/approval-policy",
  SolMgrApprover = "/solution-manager/workflow/approver",
  SolMgrStatusPolicy = "/solution-manager/workflow/status-policy",
  SolMgrOrgStructure = "/solution-manager/workflow/org-structure",
  SolMgrAssignmentHandler = "/solution-manager/workflow/assignment-handler",

  SolMgrMsgTemplate = "/solution-manager/workflow/message-template",
  SolMgrTxnType = "/solution-manager/workflow/txn-type",
  SolMgrWorkgroup = "/solution-manager/workflow/workgroup",

  // Solution Manager Security
  SolMgrUserAdmin = "/solution-manager/security/user-admin",
  SolMgrGroupAdmin = "/solution-manager/security/group-admin",
  SolMgrRoleAdmin = "/solution-manager/security/role-admin",


  // Solution Manager Security Model
  SolMgrSecurityModel = "/solution-manager/security-model-main",
  SolMgrSecuritySolutionTabSet = "/solution-manager/security/security-solution-tab-set",
  SolMgrSecurityDomain = "/solution-manager/security/security-domain",

  SolMgrSecuritySolutionTabSetPathParamSolutionId = "solutionId",


  //Payroll
  RunPayroll = "/payroll/run-payroll",
  SpecialPayroll = "/payroll/special-payroll",
  SpecialPayrollSummary = "/payroll/special-payroll-summary",
  NetPayCalculator = "/payroll/net-pay-calculator",
  PayeeMain = "/payroll/payee-main",
  PayeeDetails = "/payroll/payee-details",
  PayeeTermination = "/payroll/payee-termination",
  PayeeDocuments = "/payroll/payee-document",
  //Setting
  TaxFiling = "/payroll/tax-filing",
  ComplianceDetail = "/payroll/compliance-detail",
  WageDetermination = "/payroll/wage-determination",
  WageDeterminationSummary = "/payroll/wage-determination-summary",
  SutaFutaRates = "/payroll/suta-futa-rates",

  // DashBoard Links
  MyDashBoard = "/dashboard/main/mydashboard",



  //Terms and Conditions
  //TODO: Update the links of T&C and privacy policy
  OneLynkTermsAndConditions = "/assets/pages/Terms-Conditions.pdf",
  OneLynkPrivacyPolicy = "/assets/pages/Privacy-Policy.pdf",
  DwollaTermsAndConditions = "https://www.dwolla.com/legal/tos",
  DwollaPrivacyPolicy = "https://www.dwolla.com/legal/privacy",

  // External Links
  // Determine the county the city is in
  NocaWebSite = "https://explorer.naco.org/",

  //Quickbooks login
  QuickBooksBaseUrl = "https://rest.tsheets.com/api/v1/authorize"
}

//Enum to hold , fragment positions for Help page in the application
export enum HelpFragmentLink {
  Ach = "ach"
}

